import { Button, InlineError, Input, Spinner } from 'avo-ui'
import UploadImage from 'components/commons/upload-image'
import MultipleSelect from 'components/commons/multiple-select'
import TabToggle from 'components/commons/tab-toogle'

export const SpecialGiftCreate = ({
    specialGiftDetail,
    isLoadingUpload,
    onChangeForm,
    onSearchGift,
    optionsGift,
    isLoading,
    isCreating,
    isUpdating,
    errorForm,
    onSubmit,
}) => {
    return (
        <div className={'flex flex-col space-y-3 px-9 py-4'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <TabToggle
                        title={'Special Gift Info'}
                        content={
                            <div className={'flex space-x-16'}>
                                <div className={'flex-1 flex-col space-y-5'}>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90 required'}>Nama Special Gift</div>
                                        <Input
                                            className={'flex-1'}
                                            name={'name'}
                                            placeholder={'Masukkan nama special gift'}
                                            value={specialGiftDetail?.name}
                                            onChange={onChangeForm}
                                        />
                                        <InlineError className='mt-2' message={errorForm?.name} />
                                    </div>
                                    <div
                                        className={`flex flex-col ${(specialGiftDetail?.desktop_image_url?.base64 || specialGiftDetail?.desktop_image_url) && 'space-y-3'}`}
                                    >
                                        <div className={'font-semibold text-blue-90'}>Banner Gift Desktop</div>
                                        <UploadImage
                                            className={'w-fit'}
                                            classNameImage={
                                                '!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'
                                            }
                                            id={'banner-gift-desktop'}
                                            value={
                                                specialGiftDetail?.desktop_image_url?.base64 ||
                                                specialGiftDetail?.desktop_image_url
                                            }
                                            onChange={(value) => onChangeForm({ name: 'desktop_image_url', value })}
                                        />
                                        <InlineError className={'mt-2'} message={errorForm?.desktop_image_url} />
                                    </div>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90 required'}>
                                            Minimal Pembelanjaan
                                        </div>
                                        <Input
                                            type={'currency'}
                                            className={'flex-1'}
                                            name={'minimum_purchase'}
                                            addonBefore={'Rp'}
                                            placeholder={'Masukkan minimal pembelanjaan'}
                                            value={specialGiftDetail?.minimum_purchase}
                                            onChange={onChangeForm}
                                        />
                                        <InlineError className={'mt-2'} message={errorForm?.minimum_purchase} />
                                    </div>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90'}>Maksimal Pembelanjaan</div>
                                        <Input
                                            type={'currency'}
                                            className={'flex-1'}
                                            name={'maximum_purchase'}
                                            addonBefore={'Rp'}
                                            placeholder={'Masukkan maksimal pembelanjaan'}
                                            value={specialGiftDetail?.maximum_purchase}
                                            onChange={onChangeForm}
                                        />
                                        <InlineError className={'mt-2'} message={errorForm?.maximum_purchase} />
                                    </div>
                                </div>
                                <div className={'flex-1 flex-col space-y-5'}>
                                    <div
                                        className={`flex flex-col mt-[87px] ${(specialGiftDetail?.mobile_image_url?.base64 || specialGiftDetail?.mobile_image_url) && 'space-y-3'}`}
                                    >
                                        <div className={'font-semibold text-blue-90'}>Banner Gift Mobile</div>
                                        <UploadImage
                                            className={'w-fit'}
                                            classNameImage={
                                                '!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'
                                            }
                                            id={'banner-gift-mobile'}
                                            value={
                                                specialGiftDetail?.mobile_image_url?.base64 ||
                                                specialGiftDetail?.mobile_image_url
                                            }
                                            onChange={(value) => onChangeForm({ name: 'mobile_image_url', value })}
                                        />
                                        <InlineError className={'mt-2'} message={errorForm?.mobile_image_url} />
                                    </div>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90 required'}>Pilih Gift</div>
                                        <MultipleSelect
                                            name={'gift_ids'}
                                            placeholder={'Search Gift...'}
                                            onSearch={onSearchGift}
                                            value={specialGiftDetail?.gift_ids}
                                            options={optionsGift}
                                            onChange={onChangeForm}
                                        />
                                        <InlineError className={'mt-2'} message={errorForm?.gift_ids} />
                                    </div>
                                </div>
                            </div>
                        }
                    />
                    <div className={'flex py-3 justify-center'}>
                        <Button
                            className={'w-[200px]'}
                            loading={isLoadingUpload || isCreating || isUpdating}
                            title={'Submit'}
                            onClick={onSubmit}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
